import React, {useCallback} from 'react';
import {useEnvironment, useExperiments} from '@wix/yoshi-flow-editor';
import {classes, st} from './LineItemSection.st.css';
import {useLocaleKeys} from '../../../../locale-keys/LocaleKeys';
import {useControllerProps} from '../../Widget/ControllerContext';
import {LineItemRow} from '../LineItem/LineItem';
import {SPECS} from '../../../../common/constants';

export enum LineItemSectionDataHooks {
  root = 'LineItemSectionDataHooks.root',
  list = 'LineItemSectionDataHooks.list',
}

export const LineItemSection = () => {
  const localeKeys = useLocaleKeys();
  const {isMobile} = useEnvironment();
  const {experiments} = useExperiments();
  const {
    checkoutStore: {checkout},
  } = useControllerProps();

  const isPageHierarchyAccessible = experiments.enabled(SPECS.AccessibilityOptimizedPageHierarchy);

  const WrapperComponent = useCallback<React.FC<React.HTMLAttributes<HTMLElement>>>(
    (props) => (isPageHierarchyAccessible ? <div {...props} /> : <section {...props} />),
    [isPageHierarchyAccessible]
  );

  return (
    <WrapperComponent data-hook={LineItemSectionDataHooks.root}>
      <ul
        data-hook={LineItemSectionDataHooks.list}
        className={st(classes.itemsList, isMobile ? classes.itemsListMobile : undefined)}
        aria-label={localeKeys.checkout.orderSummary.fullSection.ariaLabel()}>
        {checkout.lineItems &&
          checkout.lineItems.map((lineItem) => (
            <LineItemRow lineItem={lineItem} key={lineItem.id} useLayoutForLongPrice={checkout.hasItemsWithLongPrice} />
          ))}
      </ul>
    </WrapperComponent>
  );
};
